import { render } from "./PanelsGroup.vue?vue&type=template&id=6aef452c&scoped=true"
import script from "./PanelsGroup.vue?vue&type=script&lang=js"
export * from "./PanelsGroup.vue?vue&type=script&lang=js"

import "./PanelsGroup.vue?vue&type=style&index=0&id=6aef452c&scoped=true&lang=scss"
import "./PanelsGroup.vue?vue&type=style&index=1&id=6aef452c&lang=scss"

import exportComponent from "/codebuild/output/src851823947/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aef452c"]])

export default __exports__